/**
 * Condensing vertical height of banner on logged-out homepage.
 */
export const HOMEPAGE_HERO_CONDENSED_HEIGHT_240806 = 'HOMEPAGE_HERO_CONDENSED_HEIGHT_240806';
